import { useRef } from 'react'
import { CalendarDays, Plus } from 'lucide-react'
import ImportantDatesTab from './ImportantDatesTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const ImportantDatesSection = ({ talentId, talentType, hasPermission }) => {
  const datesRef = useRef(null)

  return (
    <SectionBlock id="important-dates">
      <SectionHeader
        icon={CalendarDays}
        title="Important Dates"
        action={hasPermission('talent-service', `${talentType}_important_dates`, 'create') ? (
          <button
            onClick={() => datesRef.current?.openForm()}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 transition-colors"
          >
            <Plus className="h-3.5 w-3.5" />Add Date
          </button>
        ) : null}
      />
      <ImportantDatesTab ref={datesRef} talentId={talentId} talentType={talentType} showAddButton={false} />
    </SectionBlock>
  )
}

export default ImportantDatesSection
